import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { store } from './store';
import { parseQueryString } from "@/utils/query_params";
import moment from 'moment'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: i18nDefaultLanguage(),
})

function i18nSetup($root: Vue) {
  $root.$watch('$i18n.locale', (locale: string) => {
    store.locale = locale
  })

  store.$watch('locale', locale => {
    $root.$i18n.locale = locale
    moment.locale(locale)
  }, { immediate: true })
}

function i18nDefaultLanguage() {
  try {
    const q = parseHash()
    const lang = q['lang']
    if (['en', 'ja'].indexOf(lang) >= 0) {
      return q['lang']
    }
  }
  catch {
  }
  try {
    return navigator.language.split('-')[0]
  } catch {
    return 'en'
  }
}

function i18nTranslate(dict: { [locale: string]: any }, values: any = {}) {
  const template: string = dict[store.locale] || dict['en']
  if (template === undefined) {
    debugger
  }
  const message = template.replace(/\{(\w+)\}/, (match, key) => values[key])
  return message
}

function parseHash() {
  const hash = location.hash
  const i = hash.indexOf('?')
  if (i < 0) {
    return {}
  }
  return parseQueryString(hash.substring(i + 1))
}

export { i18n, i18nSetup, i18nTranslate, i18nDefaultLanguage };
